module.exports = __webpack_public_path__ + "bb6fe2912299c0cf183a67cb959e98ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/HandWhite.jpg
// module id = 1289
// module chunks = 0